/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ domain: NonNullable<unknown> }} Profile_Security_Agent_Passkey_Revoke_DescriptionInputs */



/**
* | output |
* | --- |
* | "Your AI agent will no longer be able to sign in to {domain}. The account itself is not deleted." |
*
* @param {Profile_Security_Agent_Passkey_Revoke_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_agent_passkey_revoke_description = /** @type {((inputs: Profile_Security_Agent_Passkey_Revoke_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Agent_Passkey_Revoke_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihre KI kann sich dann nicht mehr bei ${i?.domain} anmelden. Das Konto selbst wird nicht gelöscht.`)
	return /** @type {LocalizedString} */ (`Your AI agent will no longer be able to sign in to ${i?.domain}. The account itself is not deleted.`)
});